import React, { FunctionComponent, useState, useEffect } from "react";
import { withPrefix } from "gatsby";
import { VideoPlayer } from "./";
import { LiveVideoPlayerProps } from "../interfaces";
const LiveVideoPlayer: FunctionComponent<LiveVideoPlayerProps> = ({
  onError,
  onSuccess,
  videoId,
  accoundId,
  playerId,
  liveVideoId,
  dvrVideoId,
  placeholder,
  enablePlaceholder,
  liveVideoRefreshRate,
}) => {
  const [playerState, setPlayerState] = useState("live");
  const [playerRef, setPlayerRef] = useState();
  const [watchLiveButton, setWatchLiveButton] = useState();
  const [watchTime, updateWatchTime] = useState(0);

  const play = (player, videoId) => {
    player &&
      player.catalog.getVideo(videoId, (err, video) => {
        player.catalog.load(video);
        player
          .play()
          .then(() => {
            setPlayerState("live");
          })
          .catch((error) => {
            console.error("play() failed", error);
          });
      });
  };

  const handleOnSuccess = (success) => {
    let player = success.ref;
    onSuccess && onSuccess(player);
    setPlayerRef(player);

    // ADD CONTROLBAR BUTTONS
    if (liveVideoId == videoId) {
      let controlBar = document.getElementsByClassName("vjs-control-bar")[0];
      let branding = document.createElement("button");
      branding.setAttribute("class", "branding live");
      branding.textContent = "WATCH LIVE";
      branding.onclick = () => {
        player.trigger("watchLive", { videoId: liveVideoId });
      };
      controlBar.appendChild(branding);
      setWatchLiveButton(branding);
      setPlayerState("live");
    }

    player.on("watchLive", (_, data) => {
      let { videoId } = data;
      videoId &&
        player.catalog.getVideo(videoId, (err, video) => {
          if (err) {
            throw new Error(err);
          }
          player.catalog.load(video);
          player.play();
          setPlayerState("live");
        });
    });

    player.one("ended", function () {
      // console.log("player ended. switch to or emit callback");
      player.catalog.getVideo(dvrVideoId, (err, video) => {
        if (err) {
          throw new Error(err);
        }
        player.catalog.load(video);
        player.play();
        setPlayerState("dvr");
      });
    });

    player.on("error", (error) => {
      setPlayerState("error");
      onError && onError(error);
    });

    player.on("play", () => {
      setPlayerState("playing");
    });
    /**
     * Dispatched when the player is initialized,
     * and if it’s re-initialized in the case of
     * giving it a new source to play
     *
     * could be dispatched before player is ready
     */
    // player.on("loadstart", () => {
    //   console.log("loadstart");
    // });

    /**
     * Dispatched when the player has initial
     * duration and dimension information,
     * when the first segment is downloaded
     *
     * For live videos, event won't be dispatched
     * until the user clicks play
     *
     * This is a good place to do player.play()
     */
    // player.on("loadedmetadata", () => {
    //   console.log("loadedmetadata");
    // });

    /**
     * Good place to interact with the player
     */
    // player.ready(() => {
    // console.log("player.ready");
    // player.play(false);

    // const el = document.createElement("div");
    // el.innerHTML =
    //   "<iframe style='width: 100%' frameborder='0' scrolling='no' height='480' src='https://embed.actionbutton.co/widget/widget-iframe.html?widgetId=SPK-QkhDRg=='></iframe>";
    // const modalDialog = player.createModal(el, {
    //   description: "primarily for accessibility",
    //   lable: "A text label for the modal, primarily for accessibility",
    //   pauseOnOpen: true,
    //   label: "label",
    //   fillAlways: true,
    // });
    // modalDialog.on("modalclose", () => {
    //   console.log("closing");
    // });
    // modalDialog.addClass("modal__actionButton");
    // });

    /**
     * dispatched when the current playback position has changed.
     * fired every 15-250 milliseconds
     */
    // player.on("timeupdate", (e) => {
    // console.log('timeupdate', e)
    // updateWatchTime(player.currentTime());
    // // window.event = e
    // window.player = player;
    // check time
    // do work, then remove listener
    // player.off('timeupdate', timeupdateHandler);
    // });

    /**
     * Fired whenever the player is jumping to a new time
     */
    // player.on("seeking", (e) => {});
    /**
     * Fired when the player has finished jumping to a new time
     */
    // player.on("seeked", (e) => {});
    // track all analytics beacons sent
    // player.on('analytics_request', function(e) {
    //   console.log('sent a(n) ' + e.params.event + ' beacon!', e.params);
    // });

    /**
     * track specific analytics beacons sent
     * analytics_request_{beacon_name}
     *
     * https://apis.support.brightcove.com/data-collection/references/reference.html#tag/Events
     */
    // player.on('analytics_request_video_impression', function(e) {
    //   console.log('sent an impression beacon!', e.params);
    // });
  };

  useEffect(() => {
    if (playerRef && watchLiveButton) {
      if (
        videoId != liveVideoId &&
        watchLiveButton.classList.contains("live")
      ) {
        watchLiveButton.classList.remove("live");
      }
    }
  }, [playerRef, watchLiveButton, videoId, liveVideoId]);

  useEffect(() => {
    let interval: any = null;
    if (
      playerRef &&
      liveVideoRefreshRate > 0 &&
      liveVideoId &&
      playerState == "error"
    ) {
      interval = setInterval(() => {
        play(playerRef, liveVideoId);
      }, liveVideoRefreshRate);
    }
    return () => clearInterval(interval);
  }, [playerRef, playerState, liveVideoRefreshRate, liveVideoId]);

  return (
    <>
      <div className="videoWrap">
        <div className="container">
          <div className="DateBanner">
            <div className="imageEvent">
              <img
                src="https://s3.amazonaws.com/sng-global-web-assets/images/ai-week/2024/aiweekspotlight.png"
                alt="AI Week"
              />
              <h1 className="spotlight">SPOTLIGHT SERIES STAGE</h1>
              {/*<span className="daynum">DAY 3</span>
              <span className="divbreak"> | </span>
  <span className="specdate">10.20</span>*/}
            </div>
            
            <img
              src="https://s3.amazonaws.com/sng-global-web-assets/images/ai-week/2024/aiscoopspotlight24.png"
              alt="AI Scoop"
              className="imageProducer"
            />
            {/*<img
              src={withPrefix("/images/Mobile_FedTalksLogo.png")}
              alt="FedTalks presented by FedScoop"
            classN="imageMobile"*/}
          </div>
          <div className="video">
            <VideoPlayer
              accoundId={accoundId}
              playerId={playerId}
              onSuccess={handleOnSuccess}
              onError={onError}
              videoId={videoId}
              placeholder={placeholder}
              enablePlaceholder={playerState === "error"}
            />
          </div>
          <img
              src="https://s3.amazonaws.com/sng-global-web-assets/images/ai-week/2024/aiscoopspotlight24.png"
              alt="AI Scoop"
              className="imageProducer_mobile"
            />
        </div>
      </div>
    </>
  );
};

export default LiveVideoPlayer;
